import { getViewportPracticeId, viewportBaseOf } from 'lib/helpers/viewportPath';

/**
 * Resolves the route base for appointment navigation so links work in both the
 * practice portal and the admin practice viewport.
 *
 * In the admin viewport the path looks like `/admin/practices/:practiceId/...`,
 * which an admin session can access; `/portal/...` cannot and bounces to login.
 *
 * @param {string} pathname - current location pathname
 * @returns {string} `/admin/practices/:practiceId` when in the viewport, otherwise `/portal`
 */
export default function getViewportBasePath(pathname = '') {
  // Same source of truth as the axios interceptor, so a page that does NOT get
  // `practice_id` injected also does not get its links rewritten. Legacy admin
  // pages (onboarding, patient-import, …) are excluded by that regex.
  const practiceId = getViewportPracticeId(pathname);
  return practiceId ? viewportBaseOf(practiceId) : '/portal';
}
